// import { DetailedPlayerType } from "@/pages/DetailedPlayer/DetailedPlayer";
// import { EvoPathId } from "@/redux/evolutions/evolutionsSlice";
import { evolutionPathParam } from "../../evolutions/evolutionPath";
import axios from "../api";
export const getPlayer = async ({ resourceId, playerRoleId, evoPathId, evolutionPath, pathwayPath, type, }) => {
    const params = new URLSearchParams({
        ...(playerRoleId ? { "player-role-id": playerRoleId.toString() } : {}),
        ...(evoPathId ? { evoPathId: evoPathId.toString() } : {}),
        ...(evolutionPath?.length
            ? { "evolution-path": evolutionPathParam(evolutionPath, pathwayPath) }
            : {}),
        ...(type && type !== "base" ? { type } : {}),
    });
    // Build the URL properly, only adding ? if there are params
    let url = `/players/${resourceId}`;
    const queryString = params.toString();
    if (queryString) {
        url += `?v2&${queryString}`;
    }
    const res = await axios.get(url);
    return res.data;
};
//# sourceMappingURL=getPlayer.js.map